/** @jsx jsx */
import { jsx } from "theme-ui"
import { getBackgroundList } from "../helpers"

const Hero = ({ desktopImage, mobileImage, children, ...restProps }) => {
  return (
    <div
      sx={{
        minHeight: "500px",
        width: "100%",
        backgroundImage: getBackgroundList({ desktopImage, mobileImage }),
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        color: desktopImage || mobileImage ? "black" : "text",
      }}
      {...restProps}
    >
      <div
        sx={{
          maxWidth: "1340px",
          px: theme => theme.spacing.horizontal,
          width: "100%",
          mx: "auto",
          minHeight: "500px",
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default Hero
